// src/components/blades/VerticalBlade.js
import React from 'react';
import Blade from './mainblade';
import { styled } from '@mui/material/styles';

const VerticalBladeRoot = styled(Blade)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch', // Make children stretch to the container's width
  padding: theme.spacing(4),
  gap: theme.spacing(4),
}));

const VerticalBlade = ({ children, ...props }) => (
  <VerticalBladeRoot {...props}>
    {children}
  </VerticalBladeRoot>
);

export default VerticalBlade;